
<div class="flex gap-0">
  <!-- Botón principal -->
  <button class="primary-btn flex-center" (click)="emitPrimaryAction()"
          [style.border-right]="buttonType === 'default' ? 'none' : null"
          nz-button [nzType]="buttonType" nzShape="round">
    <app-st-icon class="prefix" [bold]="true" [name]="primaryIcon"></app-st-icon>
    @if (!(screenService.isMobile$ | async)) {
      <span>{{text}}</span>
    }
  </button>

  <!-- Dropdown para acciones adicionales -->
  <button class="secondary-btn" nz-button [nzType]="buttonType" nz-dropdown [nzDropdownMenu]="create" nzShape="round"
          [nzTrigger]="'click'">
    <app-st-icon [bold]="true" [name]="secondaryIcon"></app-st-icon>
  </button>
</div>

<nz-dropdown-menu #create="nzDropdownMenu">
  <ul nz-menu>
    @for (item of dropdownItems; track item.action) {
      <li (click)="emitDropdownAction(item.action)" nz-menu-item>
        {{ item.label }}
      </li>
    }
    @if (dropdownItems.length === 0) {
      <li (click)="emitSecondaryAction()" nz-menu-item>
        Crear sin plantilla
      </li>
    }
  </ul>
</nz-dropdown-menu>
